import i18n from '../../i18n';

export class Text {
  static get title(): string {
    return i18n._translate('My stats', {
      context: 'A heading above a list of stats and metrics related to the workouts completed for a period of time.',
    });
  }

  static get day(): string {
    return i18n._translate('Today', {
      context: 'A list option that can be selected to show daily stats to the user.',
    });
  }

  static get week(): string {
    return i18n._translate('Past 7 days', {
      context: 'A list option that can be selected to show weekly stats to the user for the past 7 days.',
    });
  }

  static get month(): string {
    return i18n._translate('Past 30 Days', {
      context: 'A list option that can be selected to show monthly stats to the user for the past 30 days.',
    });
  }

  static get year(): string {
    return i18n._translate('Year to date', {
      context: 'A list option that can be selected to show yearly stats to the user for the current year to date.',
    });
  }

  static get allTypes(): string {
    return i18n._translate('All types', {
      context:
        'A list option that can be selected to show stats to the user for workouts completed on any type of equipment.',
    });
  }

  static get treadmill(): string {
    return i18n._translate('Treadmill', {
      context: 'A list option that can be selected to show stats to the user for workouts completed on treadmills.',
    });
  }

  static get bike(): string {
    return i18n._translate('Bike', {
      context: 'A list option that can be selected to show stats to the user for workouts completed on exercise bikes.',
    });
  }

  static get rower(): string {
    return i18n._translate('Rower', {
      context: 'A list option that can be selected to show stats to the user for workouts completed on rower machines.',
    });
  }

  static get elliptical(): string {
    return i18n._translate('Elliptical', {
      context:
        'A list option that can be selected to show stats to the user for workouts completed on elliptical machines.',
    });
  }

  static get strength(): string {
    return i18n._translate('Strength', {
      context:
        'A list option that can be selected to show stats to the user for strength-based workouts that were completed.',
    });
  }
}
